// 1...

(function () {
  document.addEventListener('click', function (e) {
    var half = e.target.closest('.mfb-bar-half[data-action]');
    if (!half) return;

    var action = half.dataset.action;

    if (action === 'sort') {
      document.dispatchEvent(new CustomEvent('mfd-sort:open'));
    } else if (action === 'filter') {
      document.dispatchEvent(new CustomEvent('mfd:open'));
    }
  });
})();

// 2...

(function () {
  function escapeDrawersFromSidebar() {
    ['mfd-drawer', 'mfd-overlay', 'mfd-sort-drawer', 'mfd-sort-overlay'].forEach(function (id) {
      var el = document.getElementById(id);
      if (el && el.parentElement !== document.body) {
        document.body.appendChild(el);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', escapeDrawersFromSidebar);
  } else {
    escapeDrawersFromSidebar();
  }
})();

// 3...

/* ─────────────────────────────────────────────────────────────
  SCRIPT: Preserve search query (q=) across all filter interactions
  When a filter link or filter form is used on the search page, Shopify's
  filters-sorting snippet does not automatically carry the ?q= parameter
  forward, causing it to be dropped from the URL. This script:
    1. Reads the current q= value from the URL on page load.
    2. Injects it as a hidden input into every filter form (static sidebar
       and drawer).
    3. Rewrites every filter anchor href to include q= if it is missing.
    4. Uses a MutationObserver so dynamically opened drawers are also fixed.
───────────────────────────────────────────────────────────────────────────── */

(function () {
  var q = new URLSearchParams(window.location.search).get('q');
  if (!q) return;

  /* ── Inject q into every filter form that lacks it ── */
  function fixForms() {
    document.querySelectorAll(
      '#filters-aside form, #mfd-drawer form, .m6pn form, [data-filters] form'
    ).forEach(function (form) {
      if (!form.querySelector('input[name="q"]')) {
        var input = document.createElement('input');
        input.type  = 'hidden';
        input.name  = 'q';
        input.value = q;
        form.appendChild(input);
      }
    });
  }

  /* ── Append q to every filter anchor that is missing it ── */
  function fixLinks() {
    document.querySelectorAll(
      '#filters-aside a, #mfd-drawer a, .active-filter-tag a, .m6pn a'
    ).forEach(function (a) {
      try {
        var url = new URL(a.href, window.location.origin);
        /* Only touch URLs on the same origin that lack a q param */
        if (url.origin === window.location.origin && !url.searchParams.get('q')) {
          url.searchParams.set('q', q);
          a.href = url.toString();
        }
      } catch (e) { /* skip malformed hrefs */ }
    });
  }

  function fix() {
    fixForms();
    fixLinks();
  }

  /* Run immediately if DOM is ready, otherwise wait */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fix);
  } else {
    fix();
  }

  /* Re-run whenever the DOM changes (e.g. drawer opens) */
  new MutationObserver(fix).observe(document.body, {
    childList: true,
    subtree:   true
  });
})();